import { focusBorder } from "../../../theme/foundations/static";
import { InputVariant } from "../Input/Input.types";
import { textStyles } from "../../../theme/foundations/generated";
import { Size } from "./Select.types";
export const getBorderColor = (variant = InputVariant.FILLED) => {
    switch (variant) {
        case InputVariant.ERROR:
            return "semantic.border.error";
        default:
            return "semantic.border.primary";
    }
};
export const getBorderHoverColor = (variant = InputVariant.FILLED) => {
    switch (variant) {
        case InputVariant.ERROR:
            return "semantic.border.error";
        default:
            return "semantic.text.link";
    }
};
// issue without fix height on container the whole takes 50 because of borders + 2
// for multi we use max height of the content to make it grow and scrollable
// but its initial size is 50 in multi
// on input content size is 22 and padding 12 so 46 + 2 borders ...
const getHeight = ({ isMulti, size, }) => {
    if (isMulti) {
        return "unset";
    }
    return size === Size.SM ? "28px" : "48px";
};
// eslint-disable-next-line @typescript-eslint/default-param-last
export const getStyles = (variant = InputVariant.FILLED, isSearchInput, isMulti, size) => (Object.assign(Object.assign({ ".pluxee-select__placeholder": {
        color: "semantic.text.tertiary",
    }, " .pluxee-select__single-value--is-disabled": {
        color: variant === InputVariant.READONLY
            ? "semantic.text.primary !important"
            : "semantic.text.disabled !important",
    }, ".pluxee-select__menu": {
        zIndex: "dropdown",
        mt: "1",
    }, ".pluxee-select__value-container": {
        p: "0",
        ".pluxee-select__single-value": {
            m: "0",
            mr: "3",
            color: "semantic.text.primary",
        },
    }, ".pluxee-select__control": {
        flexWrap: "nowrap",
        height: getHeight({ isMulti, size }),
        p: size === Size.SM ? ".25rem .75rem" : "11px 12px",
        boxShadow: "none",
        borderColor: getBorderColor(variant),
        borderRadius: "none",
        color: "semantic.text.primary",
        fontWeight: "core.demiBold",
        fontSize: "5",
        lineHeight: "core.10",
        background: variant === InputVariant.ERROR
            ? "semantic.background.error"
            : "core.white",
        _hover: {
            background: variant === InputVariant.ERROR
                ? "semantic.background.error"
                : "core.boldyBlue.2",
            border: "1px solid",
            borderColor: getBorderHoverColor(variant),
            ".pluxee-select__placeholder": {
                color: "semantic.interactive.primary",
            },
        },
    } }, (isSearchInput
    ? {
        ".pluxee-select__control:not(.pluxee-select__control--is-focused):hover": {
            boxShadow: "large",
        },
    }
    : {})), { ".pluxee-select__control--is-focused": Object.assign(Object.assign({ background: "core.white !important" }, focusBorder), (isSearchInput
        ? { boxShadow: "medium", borderWidth: "3px !important" }
        : {})), ".pluxee-select__control--is-disabled": {
        color: variant === InputVariant.READONLY
            ? "semantic.text.primary !important"
            : "semantic.text.disabled !important",
        backgroundColor: variant === InputVariant.READONLY
            ? "transparent"
            : "semantic.background.disabled",
        borderColor: "transparent !important",
    }, ".pluxee-select__indicators": {
        // h: "6",
        ".pluxee-select__indicator": {
            mx: "0",
            p: "0",
            color: "inherit",
        },
    }, ".pluxee-select__value-container--is-multi": {
        gap: "1",
        maxHeight: "75px",
        overflow: "auto",
    }, ".pluxee-select__multi-value": {
        px: "2",
        m: 0,
        h: "6",
        display: "flex",
        alignItems: "center",
        backgroundColor: "semantic.tag.defaultEnable",
    }, ".pluxee-select__multi-value__label": Object.assign({ py: 0, pl: 0, pr: "2" }, textStyles.body.mediumBold), ".pluxee-select__multi-value__remove": {
        p: 0,
        color: "semantic.cta.secondary",
        _hover: {
            backgroundColor: "semantic.tag.defaultEnable",
            color: "semantic.text.primary",
        },
    }, ".pluxee-select__menu-list": {
        p: "0",
        shadow: "large",
        ".pluxee-select__option": {
            h: "12",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "semantic.text.primary",
            fontWeight: "core.demiBold",
            fontSize: "4",
            lineHeight: "core.9",
            _hover: {
                backgroundColor: "core.boldyBlue.2",
            },
            _focus: {
                backgroundColor: "core.white",
            },
        },
        ".pluxee-select__option--is-focused": {
            backgroundColor: "core.boldyBlue.2",
        },
        ".pluxee-select__option--is-selected": {
            backgroundColor: "semantic.surface.1",
            color: "semantic.interactive.primary",
        },
        ".pluxee-select__option--is-disabled": {
            color: "semantic.text.disabled",
            backgroundColor: "semantic.background.disabled !important",
        },
    } }));
//# sourceMappingURL=Select.styles.js.map